module.exports = __webpack_public_path__ + "static/media/blog-04.74644078.jpg";